import { Panel } from 'primereact/panel';
import { useFormContext } from 'react-hook-form';
import FormInfo from '../../../../components/messages/FormInfo';
import { DocumentDropOffFields } from '../../../../Interfaces/Accounting/ACForms.interfaces';

const DropOffSummary = () => {
  const { getValues } = useFormContext<DocumentDropOffFields>();
  const { documents, attentionTo, notes } = getValues();

  return (
    <Panel header="Info" className="max-w-600px mx-3 text-standard">
      <div className="grid">
        <div className="col-12">
          <FormInfo
            label="Documents"
            content={
              <ul className="m-0 pl-4">
                {documents.map((document) => (
                  <li key={document.name}>{document.name}</li>
                ))}
              </ul>
            }
          />
        </div>
        <div className="col-12">
          <FormInfo label="Attention To" content={attentionTo ?? '-'} />
        </div>
        <div className="col-12">
          <FormInfo label="Notes" content={notes} />
        </div>
      </div>
    </Panel>
  );
};

export default DropOffSummary;
